import React, { Component } from 'react'
import ScrollToTop from '../../../../components/ScrollToTop'
import MenuSider from '../../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../../util/IntlMessages';
import { Form, Input, Button, Select, Icon, Switch, DatePicker, message, Tooltip, Modal, Table, Spin } from 'antd';
import { Link } from 'react-router-dom'
import './Action.scss'
import axios from 'axios'
import moment from 'moment';
import { Odata_Url, Constants } from '../../../../Constants/Constants'
const Search = Input.Search
const { Column } = Table

const Option = Select.Option
const warning_job = () => {
    message.warning('Please fill detail');
};
const FormItem = Form.Item;
const { TextArea } = Input;
class Action extends Component {
    constructor() {
        super();

        var data1 = false
        var data2 = false
        const status_observed = window.localStorage.getItem("status_of_observed")
        const Detail_Category1 = JSON.parse(window.localStorage.getItem("Detail_Category"))
        const type_category = JSON.parse(window.localStorage.getItem("type_of_category"))
        const cate = JSON.parse(window.localStorage.getItem('Category'))
        const rootcause = JSON.parse(window.localStorage.getItem('Rootcause'))
        var near_miss1 = JSON.parse(window.localStorage.getItem('nearmiss'))
        var action_detail_unsafe = JSON.parse(window.localStorage.getItem('detail_unsafe'))
        var action_detail_safe = JSON.parse(window.localStorage.getItem('detail_safe'))
        var detail_capa = JSON.parse(window.localStorage.getItem('detail_capa'))

        if (action_detail_unsafe === null) {
            action_detail_unsafe = { detail1: "", detail2: "" }
            window.localStorage.setItem("detail_unsafe", JSON.stringify(action_detail_unsafe))
        }
        if (status_observed === 'safe') {
            data1 = true
        } else {
            data2 = true
        }

        if (action_detail_safe === null) {
            action_detail_safe = { detail: "" }
            window.localStorage.setItem("detail_safe", JSON.stringify(action_detail_safe))
        }


        if (near_miss1 === null) {
            near_miss1 = false
            window.localStorage.setItem("nearmiss", near_miss1)
        }

        if(detail_capa === null) {
            detail_capa = { capa_action: false, user: {}, type: 'doitandcomplete', due_date: null };
            window.localStorage.setItem("detail_capa", JSON.stringify(detail_capa))
        }

        this.state = {
            status_of_observed: data1,
            status_of_observed2: data2,
            type_of_category: type_category,
            category: cate,
            datarootcause: rootcause,
            action_of_detail_unsafe: action_detail_unsafe,
            action_of_detail_safe: action_detail_safe,
            Detail_Category: Detail_Category1,
            near_miss: near_miss1,
            observation_due_date: detail_capa.due_date,
            observation_type: detail_capa.type,
            visible: false,
            user: [],
            onloadUser: false,
            company_list: [],
            hadNextAction: true, //detail_capa.capa_action,
            tempSelectedUser: [],
            selectedUser: detail_capa.user,
            viewOnly: detail_capa.type === 'doit' || detail_capa.type === 'doitandcomplete',
            loading: false,
            mode: 'create'
        }
        this.handleSubmit_unsafe = this.handleSubmit_unsafe.bind(this)
        this.select_near_miss = this.select_near_miss.bind(this)
        this.onChange_near_miss = this.onChange_near_miss.bind(this)
        this.handleUserOk = this.handleUserOk.bind(this)
        this.handleUserCalcel = this.handleUserCalcel.bind(this)
        this.handleShowSearch = this.handleShowSearch.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    componentWillMount() {
        this.setState({ loading: true })
        let mode = (this.props.location.state || {}).mode || 'create'
        this.setState({ mode: mode })
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })

        this.getUserInfo().then(res => {
            this.setState({
                userInfo: res
            })
            if(this.state.observation_type === 'doit' || this.state.observation_type === 'doitandcomplete') {
                this.getUserInfoByUsername(res.Manager, res.ManagerEmail).then(res_u => {
                    if(res_u) {
                        this.setState({
                            selectedUser: {
                                userId: res.PKUserID,
                                userName: res.User_Name,
                                fullNameEN: res.UserFullName_ENG,
                                fullNameTH: res.UserFullName_TH,
                                email: res.Email_Address,
                                manager: res_u.PKUserID,
                                managerEmail: res.ManagerEmail,
                                cc: ''
                            },
                            viewOnly: true,
                            loading: false
                        })
                    } else {
                        // message.error('The manager not found, Please contract ITOne.');
                        this.setState({
                            selectedUser: {
                                userId: res.PKUserID,
                                userName: res.User_Name,
                                fullNameEN: res.UserFullName_ENG,
                                fullNameTH: res.UserFullName_TH,
                                email: res.Email_Address,
                                manager: null,
                                managerEmail: null,
                                cc: ''
                            },
                            viewOnly: true,
                            loading: false
                        })
                    }
                })
            } else {
                this.setState({
                    loading: false
                })
            }
        })

        this.getGroupCAPAEmail().then(res => {
            this.setState({
                company_list: res
            })
        })
    }

    handleSubmit1 = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                var detail = { detail: values.action_detail_safe }
                window.localStorage.setItem('detail_safe', JSON.stringify(detail))
                this.props.history.push({
                    pathname: "/newobservation_summary",
                    state: { Detail: values, type_of_observe: "Safe", mode: this.state.mode }
                })

            }
        })
    }

    handleBack = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                var detail = { detail: values.action_detail_safe }
                window.localStorage.setItem('detail_safe', JSON.stringify(detail))
                this.props.history.push({
                    pathname: "/newobservation_checklist",
                    state: { back: "Action_Safe", mode: this.state.mode }
                })

            }
        })
    }

    handleSubmit_unsafe = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {

                var data = []
                var data2 = []
                var pass = true
                if (values.action_detail_unsafe_1 === null && values.action_detail_unsafe_2 === null) {
                    pass = false
                }
                if (values.action_detail_unsafe_1 === "" && values.action_detail_unsafe_2 === "") {
                    pass = false
                }
                if (values.action_detail_unsafe_1 === "-" && values.action_detail_unsafe_2 === "-") {
                    pass = false
                }
                if (values.action_detail_unsafe_1 === null) {
                    values.action_detail_unsafe_1 = ""
                }
                if (values.action_detail_unsafe_2 === null) {
                    values.action_detail_unsafe_2 = ""
                }

                if (pass) {
                    var data_rootcause = []
                    this.state.category.map((l, i) => {
                        if (this.state.type_of_category[i].type === 'Unsafe') {
                            data_rootcause.push(values["rootcause" + i])
                        }
                        return null
                    });
                    // console.log(data_rootcause)
                    var detail = { detail1: values.action_detail_unsafe_1, detail2: values.action_detail_unsafe_2 }
                    window.localStorage.setItem("detail_unsafe", JSON.stringify(detail))
                    if(this.state.selectedUser.manager === null) {
                        message.error('The manager not found, Please contract ITOne.');
                        return
                    }

                    let capa = {}
                    // if(this.state.hadNextAction) {
                    //     let due_date = values.observation_due_date
                    //     due_date.toJSON = function () { return moment(this).format(); }
                    //     let dueDateStr = JSON.stringify(due_date)
                    //     let observation_due_date = dueDateStr.slice(1, 11)
                    //     capa = { capa_action: this.state.hadNextAction, user: this.state.selectedUser, type: values.observation_type, due_date: observation_due_date };
                    // } else {
                        capa = { capa_action: this.state.hadNextAction, user: this.state.selectedUser, type: values.observation_type, due_date: '' };
                    //}
                    window.localStorage.setItem("detail_capa", JSON.stringify(capa))

                    var Detail_Category1 = this.state.Detail_Category
                    var count = 0
                    this.state.type_of_category.map((l, i) => {
                        let index = Detail_Category1.findIndex(x => x.category_ID == l.cat_id)
                        if(index < 0)
                            return

                        if (l.type === 'Unsafe') {
                            Detail_Category1[index].root_cause = data_rootcause[count]
                            count++
                        } else {
                            Detail_Category1[index].root_cause = null
                        }
                    })

                    window.localStorage.setItem('Detail_Category', JSON.stringify(Detail_Category1))

                    window.localStorage.setItem('nearmiss', this.state.near_miss)
                    this.props.history.push({
                        pathname: "/newobservation_summary",
                        state: { type_of_observe: "Unsafe", root_cause: data_rootcause, mode: this.state.mode }
                    })
                } else {
                    warning_job()
                }

            }
        })
    }

    handleBackUnsafe = (e) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {

                var data = []
                var data2 = []
                var pass = true
                if (values.action_detail_unsafe_1 === null && values.action_detail_unsafe_2 === null) {
                    pass = false
                }
                if (values.action_detail_unsafe_1 === "" && values.action_detail_unsafe_2 === "") {
                    pass = false
                }
                if (values.action_detail_unsafe_1 === "-" && values.action_detail_unsafe_2 === "-") {
                    pass = false
                }
                if (values.action_detail_unsafe_1 === null) {
                    values.action_detail_unsafe_1 = ""
                }
                if (values.action_detail_unsafe_2 === null) {
                    values.action_detail_unsafe_2 = ""
                }

                if (pass) {
                    var data_rootcause = []
                    this.state.category.map((l, i) => {
                        if (this.state.type_of_category[i].type === 'Unsafe') {
                            data_rootcause.push(values["rootcause" + i])
                        }
                        return null
                    });
                    // console.log(data_rootcause)
                    var detail = { detail1: values.action_detail_unsafe_1, detail2: values.action_detail_unsafe_2 }
                    window.localStorage.setItem("detail_unsafe", JSON.stringify(detail))
                    if(this.state.selectedUser.manager === null) {
                        message.error('The manager not found, Please contract ITOne.');
                        return
                    }

                    let capa = {}
                    // if(this.state.hadNextAction) {
                    //     let due_date = values.observation_due_date
                    //     due_date.toJSON = function () { return moment(this).format(); }
                    //     let dueDateStr = JSON.stringify(due_date)
                    //     let observation_due_date = dueDateStr.slice(1, 11)
                    //     capa = { capa_action: this.state.hadNextAction, user: this.state.selectedUser, type: values.observation_type, due_date: observation_due_date };
                    // } else {
                        capa = { capa_action: this.state.hadNextAction, user: this.state.selectedUser, type: values.observation_type, due_date: '' };
                    //}
                    window.localStorage.setItem("detail_capa", JSON.stringify(capa))

                    var Detail_Category1 = this.state.Detail_Category
                    var count = 0
                    this.state.type_of_category.map((l, i) => {
                        let index = Detail_Category1.findIndex(x => x.category_ID == l.cat_id)
                        if(index < 0)
                            return

                        if (l.type === 'Unsafe') {
                            Detail_Category1[index].root_cause = data_rootcause[count]
                            count++
                        } else {
                            Detail_Category1[index].root_cause = null
                        }
                    })

                    window.localStorage.setItem('Detail_Category', JSON.stringify(Detail_Category1))

                    window.localStorage.setItem('nearmiss', this.state.near_miss)
                    this.props.history.push({
                        pathname: "/newobservation_checklist",
                        state: { back: "Action_Safe", mode: this.state.mode }
                    })
                } else {
                    warning_job()
                }

            }
        })
    }

    select_near_miss(id) {
        var Detail_Category1 = this.state.Detail_Category
        for (var i = 0; i < Detail_Category1.length; i++) {
            Detail_Category1[i].near_miss = !Detail_Category1[id].near_miss
        }
        this.setState({
            Detail_Category: Detail_Category1
        })
    }
    onChange_near_miss(checked) {
        this.setState({
            near_miss: checked
        })
    }

    handleShowSearch() {
        this.setState({
            visible: true
        })
    }

    handleSearch(str) {
        this.setState({
            onloadUser: true
        })
        const axios = require('axios');

        this.getToken().then(token => {

            let tokenHeader = {
                headers: { "Authorization": "Bearer " + token }
            };

            axios.get(Constants.BASE_URL + 'api/User/Search?q=' + str, tokenHeader)
                .then((response) => {
                    const data = [];
                    response.data.map((l, i) => {
                        data.push(l);
                    })

                    this.setState({
                        user: data,
                        onloadUser: false
                    })
                })
        });

        
    }

    handleUserOk() {
        let selectedUser = this.state.tempSelectedUser;
        this.setState({loading: true})
        if(!selectedUser.manager) {
            message.error('Manager not found, Please contract it one');
            return;
        }
        this.getUserInfoByUsername(selectedUser.manager, selectedUser.managerEmail).then(res => {
            selectedUser.manager = res.PKUserID
            this.setState({
                selectedUser: selectedUser,
                visible: false,
                loading: false
            })
        })
    }

    handleChangeCompany = value => {
        let company = this.state.company_list.find(x => x.Company === value)
        this.setState({ loading: true })
        this.getUserInfoByEmail(company.ComitteeRPEmail).then(res_rp => {
            this.getUserInfoByUsername(company.Approver, company.ComitteeRPEmail).then(res_approve => {
                this.setState({ 
                    selectedUser: {
                        userId: res_rp.PKUserID,
                        userName: res_rp.User_Name,
                        fullNameEN: res_rp.UserFullName_ENG,
                        fullNameTH: value,
                        email: company.ComitteeRPEmail,
                        cc: company.ComitteeRPEmailCC,
                        manager: res_approve.PKUserID,
                        managerEmail: res_approve.Email_Address
                    },
                    loading: false
                })
            })
        })
    }

    handleUserCalcel() {
        this.setState({
            visible: false
        })
    }

    handleChangeType = (type) => {
        if(type === 'doit' || type === 'doitandcomplete') {
            this.setState({loading: true})
            let user = this.state.userInfo
            this.getUserInfoByUsername(user.Manager, user.ManagerEmail).then(res => {
                this.setState({
                    selectedUser: {
                        userId: user.PKUserID,
                        userName: user.User_Name,
                        fullNameEN: user.UserFullName_ENG,
                        fullNameTH: user.UserFullName_TH,
                        email: user.Email_Address,
                        manager: res.PKUserID,
                        managerEmail: user.ManagerEmail,
                        cc: ''
                    },
                    viewOnly: true,
                    loading: false
                })
            })
        } else {
            this.setState({ selectedUser: {}, viewOnly: false })
        }
        this.setState({
            observation_type: type
        })
    }

    async getUserInfo(user_id_pass) {
        let user = JSON.parse(window.localStorage.getItem('User_Info'))
        let user_id = user_id_pass === undefined ? user.PKUserID : user_id_pass
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let user_info = await axios.get(
                    Odata_Url + 'OUserMD?$filter=PKUserID eq ' + user_id,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then(res => {
                    const data = [];
                    res.data.value.forEach(function (element) {
                        data.push(element);
                    });
                    return data ? data[0] : {};
                })
                return user_info;
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
            });
            return res;
    }

    async getUserInfoByEmail(email) {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let user_info = await axios.get(
                    Odata_Url + 'OUserMD?$filter=Email_Address eq \'' + email + '\'',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then(res => {
                    const data = [];
                    res.data.value.forEach(function (element) {
                        data.push(element);
                    });
                    return data ? data[0] : {};
                })
                return user_info;
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
            });
            return res;
    }

    async getUserInfoByUsername(username, email) {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let user_info = await axios.get(
                    Odata_Url + `OUserMD?$filter=User_Name eq '${username}' and Email_Address eq '${email}'`,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then(res => {
                    const data = [];
                    res.data.value.forEach(function (element) {
                        data.push(element);
                    });
                    return data ? data[0] : {};
                })
                return user_info;
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
            });
            return res;
    }

    async getGroupCAPAEmail() {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let CapaEmail = await axios.get(
                    Odata_Url + 'OGroupCAPAEmailMD',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                    return data;
                },
                (error) => {
                    console.log(error);
                })
                return CapaEmail;
            },
            (error) => {
                console.log(error);
                if (401 === error.response.status) {
                    window.location.href = "auth";
                }
            })
        return res;
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { type_of_category, category, Detail_Category } = this.state

        const view = this.state.mode === 'view'

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const arrayrootcause = this.state.datarootcause;
        var rootcause = []
        var rootcause1 = [];
        for (let i = 0; i < arrayrootcause.length; i++) {
            if (arrayrootcause[i].Ordering === 1) {
                rootcause1.push({ Rootcause: arrayrootcause[i].Rootcause, id: arrayrootcause[i].PKRootcauseID })
            }
        }
        var rootcause2 = [];
        for (let i = 0; i < arrayrootcause.length; i++) {
            if (arrayrootcause[i].Ordering === 2) {
                rootcause2.push({ Rootcause: arrayrootcause[i].Rootcause, parentid: arrayrootcause[i].Parentid })
            }
        }
        rootcause1.map((l, i) => {
            return (
                rootcause.push({
                    value: l.Rootcause,
                    label: l.Rootcause,
                    children:
                        rootcause2.filter(function (rootcause2) {
                            if (rootcause2.parentid === l.id) {
                                return true;
                            } else {
                                return false;
                            }
                        }).map((k, j) => {
                            return (
                                {
                                    value: k.Rootcause,
                                    label: k.Rootcause,
                                }
                            )
                        })
                })
            )
        })

        var Date2 = this.state.observation_due_date
        var initialValueDate
        if (Date2 !== null && Date2 !== undefined) {
            var date = Date2.slice(8, 10)
            var month = Date2.slice(5, 7)
            var year = Date2.slice(0, 4)
            var date_time = (date + "-" + month + "-" + year)
            initialValueDate = date_time
        } else {
            initialValueDate = moment()
        }

        const rowSelection = {
            type:'radio',
            onSelect: (record, selected, selectRows) => {
                this.setState({
                    tempSelectedUser: record
                })
            }
        }

        return (
            <div >
                <ScrollToTop />
                <Spin spinning={this.state.loading} size="large" style={{ top: "50%" }} tip="Loading...">

                <MenuSider title={<IntlMessages id="Action.title" />} >
                    <div className='new-observation-action'>
                        <div style={{ width: "100%" }} >
                            {/*  margin: "13px 5% 0 5%"  */}
                            {/* Safe */}
                            {
                                this.state.status_of_observed && (
                                    <span>
                                        <Form onSubmit={this.handleSubmit1} style={{ width: "100%", marginTop: "20px", fontSize: "13px" }} >
                                        <div style={{ minHeight: window.innerHeight - 94 }}>
                                            <div style={{ width: "100%", padding: "0 5%" }}>
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ width: "100%", display: "inline-block", color: "black", display: "inline-block" }} key="Job">
                                                        <IntlMessages id="Action.job_observed" />
                                                        <div style={{ marginLeft: "10px", width: "70px", backgroundColor: "green", color: "white", borderRadius: "5px", textAlign: "center", display: "inline-block" }}>
                                                            <IntlMessages id="Action.Safe" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", marginTop: "15px" }}>
                                                    <IntlMessages id="Action.current_safe" />
                                                    <FormItem>
                                                        {
                                                            getFieldDecorator('action_detail_safe', {
                                                                rules: [{
                                                                    required: false
                                                                }],
                                                                initialValue: this.state.action_of_detail_safe.detail
                                                            })(
                                                                <TextArea maxLength={2000} width="100%"
                                                                    autosize={{ minRows: 2, maxRows: 6 }}
                                                                    disabled={view}
                                                                />
                                                            )}
                                                    </FormItem>
                                                </div>
                                            </div>
                                            <div style={{ width: "100%", textAlign: "center", position: "absolute", bottom: "0" ,height: "48px" }} >
                                                <Button onClick={this.handleBack} style={{ width: "50%", height: "100%", display: "inline-block",fontSize:"18px", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                                    <Icon type="caret-left" style={{ position: "relative", top: "1px", right: "-4px" }} />
                                                    Back
                                                </Button>
                                                <Button htmlType="submit" style={{ width: "50%", height: "100%",fontSize:"18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                                    Next
                                                        <Icon type="caret-right" style={{ position: "relative", top: "1px", left: "-4px" }} />
                                                </Button>

                                            </div>
                                            </div>
                                        </Form>

                                    </span>
                                )
                            }
                            {/* Unsafe */}
                            {
                                this.state.status_of_observed2 && (
                                    <span>
                                        <Form onSubmit={this.handleSubmit_unsafe} style={{ fontSize: "13px" }} >
                                            <div style={{ minHeight: window.innerHeight - 92 }}>
                                                {/* <div> */}
                                                <div style={{ width: "100%", padding: "13px 5% 0 5% " }}>
                                                    <div style={{ width: "100%", display: "inline-block", color: "black", display: "inline-block", borderBottom: "1px solid #727574", paddingBottom: "10px" }} key="Job">
                                                        <IntlMessages id="Action.status_job_observed" />
                                                        <div style={{ marginLeft: "10px", width: "80px", backgroundColor: "red", color: "white", borderRadius: "5px", textAlign: "center", display: "inline-block" }}>
                                                            <IntlMessages id="Action.Unsafe" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ width: "100%", padding: "0 5%" }}>
                                                    <div style={{ width: "100%", marginTop: "10px" }}>
                                                        <div style={{ width: "30%", display: "inline-block", fontSize: "14px", fontWeight: "bolder", marginBottom: "10px" }}>
                                                            <IntlMessages id="Action.Category" />
                                                        </div>
                                                    </div>

                                                    {
                                                        category.map((l, i) => {
                                                            if (type_of_category[i].type === 'Unsafe') {
                                                                return (
                                                                    <div key={"root_cause" + i}>
                                                                        <div style={{ width: "100%", height: "112px", borderBottom: "1px solid #EEE", marginBottom: "2px", padding: "1px" }} key={'category' + i}>   
                                                                        <div style={{ display: "inline-block", width: "100%" }}> 
                                                                        <img className="image-category-action" src={"/images/" + l.Image_name} style={{ display: "inline-block", width: "5%",maxWidth: "20px", maxHeight: "20px" ,filter: "grayscale(100%)", objectFit: "contain",marginRight:"20px" }} /> 
                                                                       
                                                                         {this.state.isEng ? l.Category_Name_EN : l.Category_Name}
                                                                        </div>
                                                                            <div className="text-category-action" style={{ display: "inline-block", textAlign: "left" }}>   </div>
                                                                            <div style={{ fontSize: "12px", marginTop: "1px" }}>
                                                                                <div style={{ display: "inline-block", width: "15%" }}>
                                                                                <div style={{  fontSize: "14px", color: "#727574"}}> 
                                                                                <IntlMessages id="Action.rootcause" /> 
                                                                                </div>
                                                                                </div>
                                                                                < FormItem
                                                                                    // label="Root cause"
                                                                                    style={{ width: "85%", display: "inline-block" }}
                                                                                >
                                                                                    {
                                                                                        getFieldDecorator("rootcause" + i, {
                                                                                            rules: [{
                                                                                                required: true, message: 'Please select root cause!',
                                                                                            }],
                                                                                            initialValue: Detail_Category[i].root_cause
                                                                                        })(
                                                                                            <Select style={{ width: "100%" }} disabled={view} >
                                                                                                {
                                                                                                    arrayrootcause.map((k, j) => {
                                                                                                        if (k.CategoryID === l.PKCategoryID) {
                                                                                                            return (
                                                                                                                <Option value={k.Rootcause} key={"rootcause" + j}>
                                                                                                                    {this.state.isEng ? k.Rootcause_EN : k.Rootcause}
                                                                                                                </Option>
                                                                                                            )
                                                                                                        }
                                                                                                    })
                                                                                                }
                                                                                            </Select>
                                                                                        )}
                                                                                </FormItem >
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            return null
                                                        })
                                                    }
                                                </div>
                                                <div style={{ width: "100%", padding: "0 5%", marginTop: "15px" }}>
                                                    {/* <IntlMessages id="Action.current_unsafe" />
                                                    <FormItem>
                                                        {
                                                            getFieldDecorator('action_detail_unsafe_1', {
                                                                rules: [{
                                                                    required: false
                                                                }],
                                                                initialValue: this.state.action_of_detail_unsafe.detail1
                                                            })(
                                                                <TextArea maxLength={2000} width="100%"
                                                                    // placeholder="Autosize height with minimum and maximum number of lines"
                                                                    autosize={{ minRows: 2, maxRows: 6 }}
                                                                />
                                                            )}
                                                    </FormItem> */}

                                                    {/* <div>
                                                        Near miss
                                                    </div> */}
                                                    {/* Near miss for each category */}
                                                    {/* <div style={{ width: "100%", marginBottom: "15px" }}>
                                                        {
                                                            category.map((l, i) => {
                                                                if (type_of_category[i].type === 'Unsafe') {
                                                                    return (
                                                                        <div className={classNames({
                                                                            'near-miass-selected': true === Detail_Category[i].near_miss,
                                                                            'near-miass-not-selected': false === Detail_Category[i].near_miss
                                                                        })} onClick={() => this.select_near_miss(i)} style={{ width: "20%", border: "1px solid #727574", display: "inline-block", borderRadius: "3px", borderRadius: "50%", marginRight: "5px", marginTop: "5px", padding: "12px" }} key={'near-miss' + i}>
                                                                            <img src={"/images/" + l.Image_name} style={{ width: "100%", height: "100%  ", filter: "grayscale(100%)" }} />
                                                                        </div>
                                                                    )
                                                                }
                                                                return null
                                                            })
                                                        }
                                                    </div> */}
                                                    <div style={{ width: "100%", marginBottom: "10px",fontSize:"18px", fontWeight: "bolder",height: "48px"}}>
                                                        <div style={{ display: "inline-block" }}>
                                                        <Tooltip placement="top"
                                                                title="Inform this is near miss (the unplanned event that has the potential to cause human injury, environmental or equiptment damage)"
                                                            >
                                                             <IntlMessages id="Action.near_miss" />? &nbsp;&nbsp;&nbsp; 
                                                            
                                                             <Icon type="info-circle" />
                                                            </Tooltip>
                                                        </div>

                                                        <div style={{ float: "right" }}>
                                                            <Switch onChange={this.onChange_near_miss} checked={this.state.near_miss} disabled={view} />
                                                        </div>
                                                    </div>

                                                    

                                                    {/* new function by ball */}

                                                    {/* <div style={{ width: "100%", marginBottom: "10px",fontSize:"18px", fontWeight: "bolder",height: "48px"}}>
                                                        <div style={{ display: "inline-block" }}>
                                                        <Tooltip placement="top"
                                                                title="Choose this to use CAPA Action"
                                                            >
                                                             <IntlMessages id="Action.capa_action" />? &nbsp;&nbsp;&nbsp; 
                                                            
                                                             <Icon type="info-circle" />
                                                            </Tooltip>
                                                        </div>

                                                        <div style={{ float: "right" }}>
                                                            <Switch onChange={() => {this.setState({ hadNextAction: !this.state.hadNextAction })} } checked={this.state.hadNextAction} />
                                                        </div>
                                                    </div> */}
                                                {
                                                    this.state.hadNextAction ? (
                                                        <>
                                                        <IntlMessages id="Action.next_action" />
                                                        <FormItem>
                                                            {
                                                                getFieldDecorator('action_detail_unsafe_2', {
                                                                    rules: [{
                                                                        required: false
                                                                    }],
                                                                    initialValue: this.state.action_of_detail_unsafe.detail2
                                                                })(
                                                                    <TextArea width="100%"
                                                                        // placeholder="Autosize height with minimum and maximum number of lines"
                                                                        autosize={{ minRows: 2, maxRows: 6 }}
                                                                        readOnly={view}
                                                                    />
                                                                )}
                                                        </FormItem>

                                                        <IntlMessages id="Action.observation_type" />
                                                        <FormItem>
                                                            {
                                                                getFieldDecorator('observation_type', {
                                                                    rules: [{
                                                                        required: false
                                                                    }],
                                                                    initialValue: this.state.observation_type
                                                                })(
                                                                    <Select
                                                                    width="100%"
                                                                    placeholder="Select type of observation"
                                                                    onChange={this.handleChangeType}
                                                                    disabled={view}
                                                                    >
                                                                        <Option value="doitandcomplete"><IntlMessages id='doitandcomplete' /></Option>
                                                                        <Option value="doit"><IntlMessages id='doit' /></Option>
                                                                        <Option value="forward"><IntlMessages id='forward' /></Option>
                                                                        {/* <Option value="committee">เรื่องใหญ่</Option> */}
                                                                    </Select>
                                                                )}
                                                        </FormItem>
                                                        
                                                        <IntlMessages id="Action.observation_responsible" />
                                                        <FormItem>
                                                        {
                                                                getFieldDecorator('observation_responsible', {
                                                                    rules: [{
                                                                        required: false
                                                                    }],
                                                                    initialValue: this.state.isEng ? this.state.selectedUser.fullNameEN : this.state.selectedUser.fullNameTH
                                                                })(
                                                                    !this.state.viewOnly || !view ? (
                                                                        this.state.observation_type === 'committee' ? (
                                                                            <Select
                                                                            width="100%"
                                                                            placeholder="Select company"
                                                                            onChange={this.handleChangeCompany}
                                                                            >
                                                                                {
                                                                                    this.state.company_list.map((l,i) => {
                                                                                        return (
                                                                                            <Option value={l.Company}>{l.ComitteeGroup}</Option>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        ) : (
                                                                            <Search
                                                                            width="100%"
                                                                            placeholder="Select responsible"
                                                                            onSearch={this.handleShowSearch}
                                                                            readOnly={true}
                                                                            enterButton
                                                                        />
                                                                        )

                                                                    ) : (
                                                                        <Input
                                                                            width="100%"
                                                                            readOnly={true}
                                                                        />
                                                                    )
                                                                    
                                                                )}
                                                        </FormItem>

                                                        {/* <IntlMessages id="Action.observation_due_date" />
                                                        <FormItem>
                                                            {
                                                                getFieldDecorator('observation_due_date', {
                                                                    rules: [{
                                                                        required: true, message: 'Please input Due Date!',
                                                                    }],
                                                                    initialValue: moment(initialValueDate, 'DD MM YYYY'),
                                                                })(
                                                                    <DatePicker 
                                                                    style={{width: '100%'}}
                                                                    format="DD-MM-YYYY"
                                                                />
                                                                )}
                                                        </FormItem> */}
                                                </>
                                                    ) : null
                                                }
                                                   
                                                    {/* end new function by ball */}

                                                </div>
                                            </div>

                                            <Modal
                                            title="เลือกผู้รับผิดชอบ"
                                            visible={this.state.visible}
                                            onOk={this.handleUserOk}
                                            onCancel={this.handleUserCalcel}
                                            width={'95%'}
                                            >
                                                <Search placeholder="Search user" enterButton onSearch={value => this.handleSearch(value)} />
                                                <Table 
                                                rowSelection={rowSelection} 
                                                dataSource={this.state.user}
                                                loading={this.state.onloadUser}
                                                >
                                                {/* <Column
                                                    title='Username'
                                                    dataIndex='userName'
                                                /> */}
                                                <Column
                                                    title='Fullname (TH)'
                                                    dataIndex='fullNameTH'
                                                />
                                                <Column
                                                    title='Fullname (EN)'
                                                    dataIndex='fullNameEN'
                                                />
                                                <Column
                                                    title='Company'
                                                    dataIndex='company'
                                                />
                                                <Column
                                                    title='Division'
                                                    dataIndex='division'
                                                />
                                                <Column
                                                    title='Department'
                                                    dataIndex='department'
                                                />
                                                <Column
                                                    title='Email'
                                                    dataIndex='email'
                                                />
                                                </Table>
                                            </Modal>

                                            <div style={{ width: "100%", textAlign: "center", position: "relative", bottom: "0" ,height: "48px" }} >
                                                <Button onClick={this.handleBackUnsafe} style={{ width: "50%", height: "100%",fontSize:"18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                                    <Icon type="caret-left" style={{ position: "relative", top: "1px", right: "-4px" }} />
                                                    <IntlMessages id='Back' />
                                                </Button>
                                                <Button htmlType="submit" style={{ width: "50%", height: "100%",fontSize:"18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                                <IntlMessages id='Next' /> <Icon type="caret-right" style={{ position: "relative", top: "1px", left: "-4px" }} />
                                                </Button>
                                            </div>
                                        </Form>
                                    </span>
                                )
                            }
                        </div>
                    </div>
                </MenuSider>
                </Spin>
            </div >
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
        set_checklist: state.set_checklist
    }
}
const mapDispatchProps = (dispatch) => {
    return {
    }
}

const Newobservation_Action = Form.create()(Action);

export default connect(mapStatetoProps, mapDispatchProps)(Newobservation_Action)